
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const ShipmentLegs = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
         props.context.componentParent.onClickShowShipmentLegs(props);
    };

    return (
        <div className="map-icon-component">
			{/*<button onClick={handleClick} className="custom-btn label label-success" title="View Timeline"><i className="icofont icofont-tree-alt"></i> Timeline </button>
            &nbsp;| &nbsp;
            */}
            <button onClick={handleRouteClick} className="custom-btn label label-success" title="Shipment Legs"><i style={{color:"#FF0000"}} className="icofont icofont-site-map f25"></i> </button>
       
        </div>
    );
};

export default ShipmentLegs;
